import { render } from "./HorizontalFoodCard.vue?vue&type=template&id=70a51aac"
import script from "./HorizontalFoodCard.vue?vue&type=script&lang=js"
export * from "./HorizontalFoodCard.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\takht-jamshid\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__